// apiUtils.js
import { jwtDecode } from 'jwt-decode';
// Import the JSON-based configuration
import appConfig, { ENDPOINT_KEYS } from './config/appConfig';


export const changeUserDefaultProject = async ({
  corporate_account,
  user_id,
  project_id,
  login_token
}) => {
  try {
    const response = await fetch(appConfig.getUrl('/change_user_default_project'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        corporate_account,
        user_id,
        project_id
      })
    });

    const data = await response.json();
    return {
      success: data.status === 'Success',
      message: data.status_description || 'Success',
      data
    };
  } catch (error) {
    return {
      success: false,
      message: 'An error occurred while setting the default project.',
      error
    };
  }
};



export const getUserInfo = async ({
  login_token

}) => {



  try {
            const decodedToken = jwtDecode(login_token);
          const user_id = decodedToken.user_id
          console.log('appConfig.getUrl(/get_user_info) : ', appConfig.getUrl('/get_user_info'));
          
         // console.log(`user_id get_user_info  before the API call : ${user_id}`);
          const userInfoResponse = await fetch(appConfig.getUrl('/get_user_info'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': `Bearer ${login_token}`
            },
            body: JSON.stringify({
              user_id
            })
          });
         // console.log(`user_id get_user_info after the API call  : ${user_id}`);

          const userInfo = await userInfoResponse.json();
          if (userInfo.status === 'Success') {
          const user_name = userInfo.user_name;
          const corporate_account = userInfo.corporate_account;
          const user_created_date = userInfo.created_date;
          const user_updated_date = userInfo.updated_date;
          const access_level = userInfo.access_level;
          const default_project = userInfo.default_project;

           localStorage.setItem('user_id', user_id);
           localStorage.setItem('user_name', userInfo.user_name);
           localStorage.setItem('user_since', userInfo.created_date);
           localStorage.setItem('corporate_account', userInfo.corporate_account);
           localStorage.setItem('default_project', userInfo.default_project);


        //  console.log(`user_name  : ${user_name}`);
        //  console.log(`corporate_account  : ${corporate_account}`);
        //  console.log(`user_created_date  : ${user_created_date}`);
        //  console.log(`user_updated_date  : ${user_updated_date}`);
        //  console.log(`access_level  : ${access_level}`);
        //  console.log(`default_project  : ${default_project}`);

               return {
                  success: userInfo.status === 'Success',
                  message: userInfo.status_description || 'Success',
                  userInfo,
                  user_id: user_id
                };
           }
           else
                  return {
                  success: false,
                  message: 'Unable to retrieve user info',
                  userInfo,
                  user_id: user_id
                };


  } catch (error) {
    return {
      success: false,
      message: 'An error occurred while getting user info',
      error
    };
  }
};


